import Vue from "vue"
import Router from "vue-router"

import BadGateway from "@/components/ErrorPages/BadGateway.vue"
import NotFound from "@/components/ErrorPages/NotFound.vue"
import ServerError from "@/components/ErrorPages/ServerError.vue"
import Authentication from "@/modules/authentication/router"
import Dashboard from "@/modules/dashboard/router"
import Delivery from "@/modules/delivery/router"
import Keys from "@/modules/keys/router"
import Messenger from "@/modules/messenger/router"
import Offers from "@/modules/offers/router"
import Orders from "@/modules/orders/router"
import Returns from "@/modules/returns/router"
import Reviews from "@/modules/reviews/router"
import Support from "@/modules/support/router"
import Sync from "@/modules/sync/router"
// import Adversting from '@/modules/adversting/router'
// import Subscribers from '@/modules/subscribers/router'
import Tariffs from "@/modules/tariffs/router"
import removeRepeatingSlashes from "@/utils/removeRepeatingSlashes"
import { ifAuthenticated, ifNotAuthenticated } from "@/utils/routerHooks"

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...ifNotAuthenticated([Authentication]),
    ...ifAuthenticated([
      Messenger,
      Dashboard,
      Offers,
      Orders,
      Reviews,
      Delivery,
      Sync,
      Support,
      Returns,
      // Adversting, Роути перестали використовуватись через перехід на систему комісії
      // Subscribers,
      Tariffs,
      Keys
    ]),
    {
      path: "*",
      beforeEnter: (to, from, next) => {
        const fixedPath = removeRepeatingSlashes(to.fullPath)
        const { resolved } = router.resolve(fixedPath)

        if (resolved.name !== undefined) {
          next({ path: resolved.path, query: to.query })
        } else {
          next({ path: "/404" })
        }
      }
    },
    {
      path: "/404",
      component: NotFound
    },
    {
      path: "/500",
      component: ServerError
    },
    {
      path: "/502",
      component: BadGateway
    }
  ]
})

export default router
